<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Notification Type Configuration</nz-page-header-title>
      <nz-page-header-subtitle>Manage notification type configurations here</nz-page-header-subtitle>
      <nz-page-header-extra>
        @if (permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">
            Add New
          </button>
        }
      </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <div style="padding: 8px; float: right">
      <input type="text" style="width: 250px; margin-right: 8px" nz-input placeholder="Search configuration"
        [(ngModel)]="searchValue" (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()" />

      <button nz-button nzSize="small" nzType="primary" (click)="search()" style="margin-right: 8px">
        Search
      </button>

      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()">
        <i nz-icon nzType="export" nzTheme="outline"></i> Export
      </button>
    </div>

    <nz-table [nzPageSize]="100" style="width: 100%" nzBordered [nzScroll]="{ x: '1400px', y: '515px' }" nzSize="small"
      #basicTable [nzData]="this.NotificationConfigurationList" [nzLoading]="isTableLoading">
      <thead>
        <tr>
          <th nzWidth="50px" nzLeft>S.No</th>
          <th nzWidth="120px">Category Type</th>
          <th nzWidth="120px">Notification Type</th>
          <th nzWidth="120px">Sub Type</th>
          <th nzWidth="150px">Display Name</th>
          <th nzWidth="80px">Internal</th>
          <th nzWidth="80px">External</th>
          <th nzWidth="80px">Customer</th>
          <th nzWidth="80px">Event</th>
          <th nzWidth="80px">Schedule</th>
          <th nzWidth="80px">On-Demand</th>
          <th nzWidth="80px">Push</th>
          <th nzWidth="80px">Priority</th>
          <th nzWidth="80px">Ack</th>
          <th nzWidth="90px">Ack Expiry</th>
          <th nzWidth="120px">WhatsApp Template</th>
          <th nzWidth="100px">Added By</th>
          <th nzWidth="100px">Added Date</th>
          <th nzWidth="100px" nzRight style="text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (data of NotificationConfigurationList; track data; let i = $index) {
          <tr>
            <td nzLeft>{{ data.SerialNumber }}</td>
            <td>{{ data.CategoryType }}</td>
            <td>{{ data.NotificationType }}</td>
            <td>{{ data.SubType || '-' }}</td>
            <td>{{ data.DisplayName }}</td>
            <td>{{ data.InternalAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.ExternalAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.CustomerAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.EventAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.SchedulingAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.OnDemandAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.PushNotificationAllowed ? 'Yes' : 'No' }}</td>
            <td>{{ data.PushNotificationAllowed ? (data.PushPriorityLevel || 'normal') : '-' }}</td>
            <td>{{ data.PushNotificationAllowed ? (data.RequiresAcknowledgement ? 'Yes' : 'No') : '-' }}</td>
            <td>{{ data.RequiresAcknowledgement && data.ExpiryDurationHours ? data.ExpiryDurationHours + 'h' : '-' }}</td>
            <td>{{ data.WhatsAppTemplateName || '-' }}</td>
            <td>{{ data.AddedBy }}</td>
            <td>{{ data.AddedDate | DatetimeConverter }}</td>
            <td nzRight style="text-align: center">
              @if (permission.Edit) {
                <button class="btn btn-sm btn-light-primary" (click)="editConfiguration(data)">
                  Edit
                </button>
              }
              &nbsp;
              @if (permission.Delete) {
                <button class="btn btn-sm btn-light-danger" (click)="handleDelete(data)">
                  Delete
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '80px' }" nzWidth="900px" [nzTitle]="modalTitle"
      [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">
      <ng-template #modalTitle>{{ ConfigurationTitle }}</ng-template>

      <ng-template #modalContent>
        <form nz-form>
          <div nz-row [nzGutter]="20">
            <div nz-col [nzSpan]="10">
              <nz-form-item>
                <nz-form-label [nzSpan]="10" nzRequired>Category Type</nz-form-label>
                <nz-form-control [nzSpan]="14">
                  <nz-select [(ngModel)]="NewNotificationConfiguration.CategoryType" name="CategoryType"
                    nzPlaceHolder="Select Category" (ngModelChange)="onCategoryTypeChange($event)" nzAllowClear>
                    @for (category of categoryTypeOptions; track category) {
                      <nz-option [nzValue]="category.value"
                      [nzLabel]="category.label"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="10" nzRequired>Notification Type</nz-form-label>
                <nz-form-control [nzSpan]="15">
                  <nz-select [(ngModel)]="NewNotificationConfiguration.NotificationType" name="NotificationType"
                    nzPlaceHolder="Select Type" [nzDisabled]="!NewNotificationConfiguration.CategoryType"
                    (ngModelChange)="onNotificationTypeChange($event)" nzAllowClear>
                    @for (type of getFilteredNotificationTypes(); track type) {
                      <nz-option [nzValue]="type.value"
                      [nzLabel]="type.label"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="16">
              <nz-form-item>
                <nz-form-label [nzSpan]="6">Sub Type</nz-form-label>
                <nz-form-control [nzSpan]="16">
                  <nz-select [(ngModel)]="NewNotificationConfiguration.SubType" name="SubType"
                    nzPlaceHolder="Select SubType" [nzDisabled]="!shouldShowSubType()" nzAllowClear>
                    @for (subType of getFilteredSubTypes(); track subType) {
                      <nz-option [nzValue]="subType.value"
                      [nzLabel]="subType.label"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <nz-form-item>
            <nz-form-label [nzSpan]="4" nzRequired>Display Name</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <input nz-input [(ngModel)]="NewNotificationConfiguration.DisplayName" name="DisplayName"
                placeholder="Enter display name" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="4">Description</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <textarea nz-input [(ngModel)]="NewNotificationConfiguration.Description" name="Description"
              placeholder="Enter description (optional)" rows="2"></textarea>
            </nz-form-control>
          </nz-form-item>

          <nz-divider nzText="Permission Settings"></nz-divider>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">Internal Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.InternalAllowed"
                  name="InternalAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">External Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.ExternalAllowed"
                  name="ExternalAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">Customer Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.CustomerAllowed"
                  name="CustomerAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <nz-divider nzText="Trigger Type Capabilities"></nz-divider>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">Event Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.EventAllowed" name="EventAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">Scheduling Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.SchedulingAllowed"
                  name="SchedulingAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="12">On-Demand Allowed</nz-form-label>
                <nz-form-control [nzSpan]="12">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.OnDemandAllowed"
                  name="OnDemandAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="8">Scheduling Required</nz-form-label>
                <nz-form-control [nzSpan]="16">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.SchedulingRequired"
                  name="SchedulingRequired"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="8">Sort Order</nz-form-label>
                <nz-form-control [nzSpan]="16">
                  <nz-input-number [(ngModel)]="NewNotificationConfiguration.SortOrder" name="SortOrder" [nzMin]="0"
                  [nzMax]="9999" style="width: 100%"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          @if (NewNotificationConfiguration.SchedulingAllowed) {
            <div nz-row [nzGutter]="16">
              <div nz-col [nzSpan]="16">
                <nz-form-item>
                  <nz-form-label [nzSpan]="6" [nzRequired]="NewNotificationConfiguration.ScheduleActive">Schedule (CRON)</nz-form-label>
                  <nz-form-control [nzSpan]="18">
                    <input nz-input name="CronExpression"
                      [(ngModel)]="NewNotificationConfiguration.CronExpression"
                      placeholder="e.g. 0 0 * * * — every day at midnight" />
                    @if (cronScheduleDescription) {
                      <div class="mt-2"
                        [class.text-success]="cronScheduleDescription !== 'Invalid CRON expression'"
                        [class.text-danger]="cronScheduleDescription === 'Invalid CRON expression'">
                        <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                        {{ cronScheduleDescription }}
                      </div>
                    }
                    <div class="text-muted mt-1" style="font-size: 12px;">
                      One shared schedule for this type. Recipients opt in on the Notification Group page.
                      Examples: "0 0 * * *" daily midnight, "0 0 * * MON" Mondays, "0 */4 * * *" every 4 hours.
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzSpan]="12">Schedule Active</nz-form-label>
                  <nz-form-control [nzSpan]="12">
                    <nz-switch [(ngModel)]="NewNotificationConfiguration.ScheduleActive" name="ScheduleActive"></nz-switch>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          }

          <nz-divider nzText="Template Settings"></nz-divider>

          <nz-form-item>
            <nz-form-label [nzSpan]="4">WhatsApp Template</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-select [(ngModel)]="NewNotificationConfiguration.WhatsAppTemplateMasterId"
                name="WhatsAppTemplateMasterId" nzPlaceHolder="Select WhatsApp Template (optional)" nzAllowClear>
                @for (template of WhatsAppTemplateList; track template) {
                  <nz-option [nzValue]="template.WhatsAppTemplateMasterId"
                  [nzLabel]="template.ProviderTemplateName + ' - ' + template.ProviderName"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-divider nzText="Push Notification Settings"></nz-divider>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="8">
              <nz-form-item>
                <nz-form-label [nzSpan]="14">Push Allowed</nz-form-label>
                <nz-form-control [nzSpan]="10">
                  <nz-switch [(ngModel)]="NewNotificationConfiguration.PushNotificationAllowed"
                  name="PushNotificationAllowed"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
            @if (NewNotificationConfiguration.PushNotificationAllowed) {
              <div nz-col [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzSpan]="14">Priority Level</nz-form-label>
                  <nz-form-control [nzSpan]="10">
                    <nz-select [(ngModel)]="NewNotificationConfiguration.PushPriorityLevel" name="PushPriorityLevel"
                      nzPlaceHolder="Select Priority">
                      <nz-option nzValue="low" nzLabel="Low"></nz-option>
                      <nz-option nzValue="normal" nzLabel="Normal"></nz-option>
                      <nz-option nzValue="high" nzLabel="High"></nz-option>
                      <nz-option nzValue="critical" nzLabel="Critical"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            }
            @if (NewNotificationConfiguration.PushNotificationAllowed) {
              <div nz-col [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzSpan]="14">Requires Ack</nz-form-label>
                  <nz-form-control [nzSpan]="10">
                    <nz-switch [(ngModel)]="NewNotificationConfiguration.RequiresAcknowledgement"
                    name="RequiresAcknowledgement"></nz-switch>
                  </nz-form-control>
                </nz-form-item>
              </div>
            }
          </div>
          @if (NewNotificationConfiguration.PushNotificationAllowed && NewNotificationConfiguration.RequiresAcknowledgement) {
            <div
              style="margin-bottom: 16px;">
              <small style="color: #faad14;"><i nz-icon nzType="warning"></i> Users must acknowledge this notification
            before using the app</small>
          </div>
        }

        @if (NewNotificationConfiguration.PushNotificationAllowed && NewNotificationConfiguration.RequiresAcknowledgement) {
          <div nz-row [nzGutter]="16"
            >
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="10">Expiry Duration (Hours)</nz-form-label>
                <nz-form-control [nzSpan]="14">
                  <nz-input-number [(ngModel)]="NewNotificationConfiguration.ExpiryDurationHours"
                    name="ExpiryDurationHours" [nzMin]="1" [nzMax]="720" [nzStep]="1"
                  nzPlaceHolder="e.g. 24" style="width: 100%"></nz-input-number>
                  <div class="mt-1 text-muted">
                    <small><i nz-icon nzType="info-circle"></i> Leave empty for no expiry. Acknowledgement will expire
                  after the specified hours.</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      }

      <nz-form-item>
        <nz-form-label [nzSpan]="4">Is Default</nz-form-label>
        <nz-form-control [nzSpan]="20">
          <nz-switch [(ngModel)]="NewNotificationConfiguration.IsDefault" name="IsDefault"></nz-switch>
          <span style="margin-left: 8px; color: #666;">Set as default configuration for this category</span>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">
      Cancel
    </button>
    @if (permission.Add || permission.Edit) {
      <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoading"
        >
        Save Configuration
      </button>
    }
  </ng-template>
</nz-modal>
</div>
</div>